import {useMemo} from "react";
import { ReactComponent as ArrowDown } from "../../assets/images/arrow-down.svg";
import { ReactComponent as ArrowUp } from "../../assets/images/arrow-up.svg";
import { formatTimeSinceShort } from "../../hooks/formatTimeSince";
import { formatFullNumber } from "../../hooks/formatNumber";
import { formatDate } from "../admin/helper/formatters";
import { IVideoListDataItem } from "../../constants/interfaces";
import Line from "../widgets/listWidget/listItem/Line";
import useGetEnvironment from "../../hooks/useGetEnvironment";

type Props = {
	data: IVideoListDataItem;
	lineSum: number,
	lineWidth: number,
	numberFields: Array<string>;
};

const VideoListItem = (props: Props) => {
	const { data, numberFields, lineSum, lineWidth } = props;
	const { timestamp, title, trend } = data;
	const add = trend >= 0;
	const getEnvironment = useGetEnvironment();

	const createUrl = useMemo(()=>{
		let url = "";
		const environment = getEnvironment();
		if (environment === "staging" || environment === "staging2") {
			url = `https://${data.brandId}-${environment}.smartocto.com/#/videos/${data.relationId}/`
		} else {
			url = `https://${data.brandId}.smartocto.com/#/videos/${data.relationId}/`;
		}
		return url
	},[data.brandId, data.relationId, getEnvironment])

	return (
		<div className="list-item">
			<div className="list-item__row list-item__row--social-icons">
				<p className="list-item__timeframe">
					{formatTimeSinceShort(Date.parse(timestamp))}
				</p>
			</div>
			<div className="list-item__row">
				<div className="list-item__header">
					{add ? (
						<ArrowUp className="list-item__arrow" />
					) : (
						<ArrowDown className="list-item__arrow" />
					)}
					<h3 className="list-item__title ">
						{createUrl ? (
							<a href={createUrl} target="_blank" rel="noreferrer">
								{title}
							</a>
						) : (
							title
						)}
					</h3>
				</div>
				{numberFields.map((field, idx) => {
					if (data[field]) {
						if (field === "pubdate") {
							return (
								<p className="list-item-stat date" key={idx}>
									{formatDate(data[field])}
								</p>
							);
						}
						return (
							<p className="list-item-stat" key={idx}>
								{formatFullNumber(data[field])}
							</p>
						);
					} else {
						return (
							<p className="list-item-stat" key={idx}>
								n/a
							</p>
						);
					}
				})}
			</div>
			<Line data={data} width={lineWidth} sum={lineSum} />
		</div>
	);
};

export default VideoListItem;
